import React, { useEffect } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore from 'swiper'

import LazyLoad from 'react-lazy-load'

import 'swiper/css'
import 'swiper/css/navigation'

import './Slider.scss'

import { Autoplay ,Navigation } from 'swiper/modules'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function Slider() {
  useEffect(() => {
    Aos.init({ duration: 2500 })
  }, [])
  SwiperCore.use([Autoplay])

  return (
    <>
      <LazyLoad offset={300}>
      <Swiper 
        speed={1800}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }} navigation={true} modules={[Autoplay,Navigation]} className="mySwiper">
        <SwiperSlide>
          <div className='sliderOne'>
            <div className="wrapper">
              <div className="container">
                <p data-aos='fade-up'>
                  SICAK DERİN<br />
                  GALVANİZLİ TEL
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className='sliderTwo'>
            <div className="wrapper">
              <div className="container">
                <p>
                  GLOBAL İHRACAT<br />
                  ÇELİK ÜRÜNLER
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className='sliderThree'>
            <div className="wrapper">
              <div className="container">
                <p>
                  YAPI
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
          <div className='sliderFour'>
            <div className="wrapper">
              <div className="container">
                <p>
                  ATIK<br />
                  ENERJİ SANTRALİ
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide> */}
      </Swiper>
      </LazyLoad>
    </>
  )
}
